var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"18","height":"9","viewBox":"0 0 18 9","fill":"#919DAF","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.995 5.952l3.952 3.016 6.347-7.253L10.04.618l-5.32 6.08-2.714-2.071-1.01 1.325zm16.133-4.237L15.873.618l-5.308 6.066-.628-.502-1.041 1.302 1.872 1.498 6.36-7.267z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }